// extracted by mini-css-extract-plugin
module.exports = {"sticky_cta_btn_container":"CallNowBookOnlineStickyCTA_sticky_cta_btn_container__0WW5W"};